import withQuery from 'with-query';

import {
  CCASSQueryDetailsResponse,
  CCASSQueryResponse,
  CCASSStatisticResponse,
  CCASSSummaryStatisticsResponse,
} from '../py-generated/datalouder/ccass/types';
import { CCASSStatisticsResponseBody } from '../shared/types';
import { apiUrl, apiv2Url } from './config';
import { getOption, getPromise, RequestOptions } from './utils';

interface CCASSQueryParams {
  ticker: string;
  date: string;
  comparedToDate: string;
}

const query = (
  ticker: string,
  date: string,
  comparedToDate: string
): Promise<CCASSQueryResponse> =>
  getPromise<CCASSQueryParams, CCASSQueryResponse>(
    `${apiv2Url}/ccass/query`,
    { ticker, date, comparedToDate },
    data => data
  );

const queryDetails = (
  ticker: string,
  date: string,
  comparedToDate: string
): Promise<CCASSQueryDetailsResponse> =>
  getPromise<CCASSQueryParams, CCASSQueryDetailsResponse>(
    `${apiv2Url}/ccass/query/details`,
    { ticker, date, comparedToDate },
    data => data
  );

const statistics1 = (abortSignal: AbortSignal, dateStr: string): Promise<any> =>
  getPromise<{ date: string }, CCASSStatisticsResponseBody>(
    `${apiUrl}/ccass/statistics`,
    { date: dateStr },
    undefined,
    abortSignal
  );

const statistics2 = (
  abortSignal: AbortSignal,
  dateStr: string
): Promise<CCASSSummaryStatisticsResponse> =>
  getPromise<{ date: string }, CCASSSummaryStatisticsResponse>(
    `${apiv2Url}/ccass/summary_statistics`,
    { date: dateStr },
    undefined,
    abortSignal
  );

const detailStatistics = (
  abortSignal: AbortSignal,
  dateStr: string
): Promise<CCASSStatisticResponse> =>
  getPromise<{ date: string }, CCASSStatisticResponse>(
    `${apiv2Url}/ccass/participant_statistics`,
    { date: dateStr },
    undefined,
    abortSignal
  );

const summaryHistory = (
  abortSignal: AbortSignal,
  stockCode: string
): Promise<any> =>
  getPromise<any, any>(
    `${apiv2Url}/ccass/summary_history`,
    { stockCode },
    undefined,
    abortSignal
  );

const participantHistory = (
  abortSignal: AbortSignal,
  stockCode: string
): Promise<any> =>
  getPromise<any, any>(
    `${apiv2Url}/ccass/participant_history`,
    { stockCode },
    undefined,
    abortSignal
  );

const stockNewsOptions = (
  normalizedStockCode: string,
  lang: string,
  lastNewsId?: number
): RequestOptions => ({
  url: withQuery(`${apiv2Url}/news/list`, {
    stockCode: normalizedStockCode,
    lang,
    lastNewsId,
  }),
  ...getOption(),
});

const latestStockNews = (
  abortSignal: AbortSignal,
  language: string
): Promise<any> =>
  getPromise<any, any>(
    `${apiv2Url}/news/latest`,
    { lang: language },
    undefined,
    abortSignal
  );

const viewNewsOptions = (newsId: number): RequestOptions => {
  return {
    url: withQuery(`${apiv2Url}/news/view`, { newsId }),
    ...getOption(),
  };
};

export default {
  query,
  queryDetails,
  statistics1,
  statistics2,
  detailStatistics,
  summaryHistory,
  participantHistory,
  stockNewsOptions,
  latestStockNews,
  viewNewsOptions,
};
